export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Veuillez ouvrir une session Sephora',
        termsOfUseLink: 'conditions d’utilisation de Sephora',
        privacyPolicyLink: 'Politique de confidentialité',
        wantToSaveYourPoints: `Envie d’économiser vos ${vars[0]} points?`,
        pointsAndFreeShip: `Ouvrez une session pour enregistrer vos *${vars[0]} points Beauty Insider*, profiter de la *livraison standard GRATUITE* et échanger vos points pour des récompenses gratuites.`,
        pointsForBooking: `Ouvrez une session pour recevoir vos *${vars[0]} points Beauty Insider* à la fin de votre service.`,
        signInHeading: 'Sign In',
        signInMarketing: `Sign In to save your *${vars[0]} Beauty Insider points*, get *FREE standard shipping* & redeem your free rewards.`,
        credentialFieldLabel: 'Phone or Email Address',
        credentialFieldPlaceholder: '(123) 456-7890',
        continueButton: 'Continue',
        signInButton: 'Sign In'
    };

    return resources[label];
}
